import React from 'react';
import { Container } from 'semantic-ui-react';
import { Helmet } from '@plone/volto/helpers/Helmet/Helmet';
import { Link } from 'react-router-dom';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import 'volto-facultycv/directory.css';

const ProfileStaff = ({ content }) => {
  const formatDepartmentLink = (dept) => {
    return dept
      .replace(/[,.]/g, '')
      .replace(/\band\b/g, '')
      .replace(/\s+/g, '-')
      .toLowerCase();
  };

  return (
    <Container>
      <div>
        <Helmet title={`${content.title} — York College / CUNY`} />

        <div className="block hero">
          <div className="block-inner-wrapper">
            {content.image && <img src={content.image.scales.mini.download} alt={content.title} className="hero-image portraitPhoto" loading="lazy" />}

            <div className="hero-body">
              <div className="hero-text">
                <h1>{content.title}</h1>
                <p className="documentDescription">
                  <strong>
                    {content.teachingTitle && (
                      <>
                        {content.teachingTitle}
                        <br />
                      </>
                    )}
                    {content.otherTitle}
                    {['Chair', 'Acting Chair'].includes(content.orgStatus) && (
                      <>
                        {' '}
                        and {content.orgStatus}
                        <br />
                      </>
                    )}
                  </strong>
                  <br />
                  {content.dept && (
                    <Link to={flattenToAppURL(`/${formatDepartmentLink(content.dept)}`)}>
                      <strong>{content.dept}</strong>
                    </Link>
                  )}
                </p>

                <p>
                  Phone: {content.officePhone}
                  <br />
                  Office Location: {content.officeLocation}
                  <br />
                  Email: {content.email && (
                    <a href={`mailto:${content.email}`}>
                      <strong>{content.email}</strong>
                    </a>
                  )}
                </p>
              </div>
              {content.website && (
                <div className="link-more">
                  <a href={content.website} target="_blank" rel="noopener noreferrer" className="external">
                    Personal Website
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ProfileStaff;
